"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTopCities = void 0;
/*
* Популярные города по весу(топ-7), выводимые на сайте.
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/48be3ae7afca61dc4db4c977c3115c60
*/
exports.getTopCities = function (providerId) { return ({
    uri: '/v1/geography/get-top-cities',
    method: 'GET',
    headers: { 'ProviderId': "" + providerId },
}); };
